import { NgOptimizedImage } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { isDefined } from "@recursyve/nice-ts-utils";
import { SvgIconComponent } from "angular-svg-icon";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import { GetDirectusFilePipe } from "../../../../common/pipes/get-directus-file.pipe";
import { GetDirectusImagePipe } from "../../../../common/pipes/get-directus-image.pipe";
import {
    sanitizeDirectusArray,
    sanitizeDirectusObject,
    sanitizeDirectusRelationArray
} from "../../../../common/utils/sanitize-directus-object";
import { Files } from "../../../api/packbo/models/files";
import { ItemsResourceBlock } from "../../../api/packbo/models/items-resource-block";
import { FileSizePipe } from "./pipes/file-size.pipe";

@Component({
    selector: "packbo-resource-block",
    templateUrl: "./resource-block.template.html",
    imports: [
        DirectusTranslationPipe,
        GetDirectusFilePipe,
        GetDirectusImagePipe,
        NgOptimizedImage,
        SvgIconComponent,
        TranslocoPipe,
        FileSizePipe
    ]
})
export class ResourceBlockComponent {
    public readonly resourceBlock = input.required<ItemsResourceBlock>();
    public readonly isLast = input(false);
    public readonly resources = computed(() =>
        sanitizeDirectusRelationArray(this.resourceBlock().resources_refs, "resources_id")
            .map(sanitizeDirectusObject)
            .filter(isDefined)
    );

    public readonly firstCategory = computed(() =>
        this.resources()
            .map((resource) => sanitizeDirectusObject(resource.categorie_ref))
            .find(isDefined)
    );

    public readonly file = computed(() => {
        const files = sanitizeDirectusArray(
            this.resources()?.map((resource) => sanitizeDirectusObject(resource.file_ref))
        );
        if (!files) {
            return [];
        }
        return files.map((file) => file as Files);
    });
}
